import React from 'react';

import { MagicStar, Star1 } from 'iconsax-react';

import LinkButton from '@core/components/linkbutton/LinkButton';

import avatar1 from 'assets/images/pages/homepage/newsletter-avatars/ImageWithFallback.png';
import avatar2 from 'assets/images/pages/homepage/newsletter-avatars/ImageWithFallback-1.png';
import avatar3 from 'assets/images/pages/homepage/newsletter-avatars/ImageWithFallback-2.png';
import avatar4 from 'assets/images/pages/homepage/newsletter-avatars/ImageWithFallback-3.png';
import avatar5 from 'assets/images/pages/homepage/newsletter-avatars/ImageWithFallback-4.png';
import avatar6 from 'assets/images/pages/homepage/newsletter-avatars/ImageWithFallback-5.png';

import classes from './Newsletter.module.scss';

const AVATARS = [
    { id: 'a1', image: avatar1 },
    { id: 'a2', image: avatar2 },
    { id: 'a3', image: avatar3 },
    { id: 'a4', image: avatar4 },
    { id: 'a5', image: avatar5 },
    { id: 'a6', image: avatar6 },
];

const STATS = [
    { id: 'professionals', value: '80K+', label: 'Professionals' },
    { id: 'courses', value: '50+', label: 'Courses' },
    { id: 'pass-rate', value: '96%', label: 'Pass rate' },
];

const CTA_HREF = '/login';

const Newsletter = () => {
    return (
        <section id='subscription' className={classes['newsletter']}>
            <div className='container'>
                <div className={classes['newsletter__card']}>
                    <div className={classes['newsletter__main']}>
                        <span className={classes['newsletter__badge']}>
                            <MagicStar size={18} color='#18BBA8' variant='Bold' />
                            Trusted by pharma leaders worldwide
                        </span>

                        <h2 className={classes['newsletter__title']}>
                            Join 80K+ pharma professionals leveling up their careers
                        </h2>

                        <div className={classes['newsletter__reviews']}>
                            <div className={classes['newsletter__avatars']}>
                                {AVATARS.map((avatar) => (
                                    <span key={avatar.id} className={classes['newsletter__avatar']}>
                                        {avatar.image && <img src={avatar.image.src} alt='Pharmuni learner' />}
                                    </span>
                                ))}
                            </div>
                            <div className={classes['newsletter__rating']}>
                                <div className={classes['newsletter__stars']}>
                                    {[0, 1, 2, 3, 4].map((star) => (
                                        <Star1 key={star} size={18} color='#faa61a' variant='Bold' />
                                    ))}
                                </div>
                                <span className={classes['newsletter__rating-text']}>4.7 / 5 User reviews stars</span>
                            </div>
                        </div>

                        <div className={classes['newsletter__stats']}>
                            {STATS.map((stat) => (
                                <div key={stat.id} className={classes['newsletter__stat']}>
                                    <span className={classes['newsletter__stat-value']}>{stat.value}</span>
                                    <span className={classes['newsletter__stat-label']}>{stat.label}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className={classes['newsletter__aside']}>
                        <p className={classes['newsletter__aside-text']}>
                            Build real skills, get certified, and advance fast in the pharma industry.
                            <br />
                            Ready to stand out?
                        </p>
                        <LinkButton kind='primary-color' href={CTA_HREF} className={classes['newsletter__cta']}>
                            Get started — it&apos;s free
                        </LinkButton>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Newsletter;
